import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Back",
  "use": "Back-usage",
  "viewBox": "0 0 36 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 26\" id=\"Back\"><path fill-rule=\"evenodd\" d=\"M24.675 10.719H.562v5.185h24.321l-5.435 5.47 4.002 4.03 11.985-12.06-4.076-3.957-8.786-8.84-4.002 4.03 6.104 6.142z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol